import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetFlowRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetFlowResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getFlow = (request: GetFlowRequest, options?: CashRequestOptions) =>
  post<GetFlowRequest, GetFlowResponse>('/2.0/cash/get-flow', request, { ...options, rejectOnError: true })
